import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page" }

import { PanelTheme } from "@/common/themes";
import { tabMenu } from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  props: {
    tabActive: {},
    menuList: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_unref(tabMenu), {
          tabs: __props.menuList,
          active: __props.tabActive
        }, {
          title: _withCtx(() => [
            _renderSlot(_ctx.$slots, "title")
          ]),
          content: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _: 3
        }, 8, ["tabs", "active"])
      ])
    ]),
    _: 3
  }))
}
}

})